import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, unref as _unref, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  key: 0,
  id: "events-list-table-description"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("small", null, "Events list", -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-md-6 col-lg-4 col-xl-3" }
const _hoisted_6 = {
  style: {"height":"24px"},
  class: "mt-2"
}
const _hoisted_7 = {
  key: 1,
  class: "table-responsive"
}
const _hoisted_8 = {
  "aria-describedby": "events-list-table-description",
  class: "table table-borderless table-sm"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "Date"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "Calendar"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "Title"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "Info"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "Actions")
  ])
], -1)
const _hoisted_10 = { class: "app-date-td" }
const _hoisted_11 = {
  class: "btn-group",
  role: "group",
  "aria-label": "actions"
}

import { format_date } from '@/helpers/filters'
import { EVENT_NAME__EVENT_NOT_REMOVED, EVENT_NAME__EVENT_REMOVED } from '@/api/EventsApi'
import DistancePresentation from '@/components/calendar/EventExtraField/Presentation/DistancePresentation.vue'
import GeolocationPresentation from '@/components/calendar/EventExtraField/Presentation/GeolocationPresentation.vue'
import PhotosPresentation from '@/components/calendar/EventExtraField/Presentation/PhotosPresentation.vue'
import PricePresentation from '@/components/calendar/EventExtraField/Presentation/PricePresentation.vue'
import VolumePresentation from '@/components/calendar/EventExtraField/Presentation/VolumePresentation.vue'
import ListManager, { BaseData, BaseLock } from '@/uiManagers/ListManager'
import { Calendar, Event, ListResponse, Paging, Query, Uuid } from '@/types/api'
import { inject, onBeforeMount, reactive, ref } from 'vue'
import { extraFieldTypes } from '@/components/calendar/EventExtraField/data'
import { calendarsApi, eventsApi } from '@/di/api'
import eventBus from '@/di/eventBus'
import { notifyInjectionKey } from '@/keys'
import { useRouter } from "vue-router";
import { Notify } from "@/types/app";
import AppPagination from "@/components/app/AppPagination.vue";
import AppLoadingMessage from "@/components/app/AppLoadingMessage.vue";
import AppEmptyListAlert from "@/components/app/AppEmptyListAlert.vue";
import AppIconLoadingButton from "@/components/app/AppIconLoadingButton.vue";
import AppIcon from "@/components/app/AppIcon.vue";


// eslint-disable-next-line @typescript-eslint/no-empty-interface

export default /*#__PURE__*/_defineComponent({
  __name: 'EventList',
  setup(__props) {

class EventListManager extends ListManager<Event, Query, BaseLock, BaseData<Event>> {

}

const router = useRouter()

const model = ref<Query & { filter: { calendar_id: string | null } }>({
  paging: { page: 1, per_page: 10 },
  filter: { calendar_id: null }
})

const lock = reactive<BaseLock & { preparing: boolean }>({
  itemsLoading: false,
  removingId: null,
  preparing: false
})

const data = reactive<BaseData<Event>>({ presentation: { items: [], total_count: 0 } })
const calendars = ref<Calendar[]>([])

const eventListManager = new EventListManager(
    router,
    inject(notifyInjectionKey) as Notify,
    eventBus,
    model,
    lock,
    data,
    (query: Query): Promise<ListResponse<Event>> => eventsApi.getEvents(query),
    (itemId: Uuid): Promise<void> => eventsApi.removeEvent(itemId),
    {
      removed: EVENT_NAME__EVENT_REMOVED,
      notRemoved: EVENT_NAME__EVENT_NOT_REMOVED
    },
    ((event: { event_id: Uuid }): Uuid => event.event_id) as (event: object) => Uuid
)

const removeItem = async (itemId: Uuid): Promise<void> => {
  await eventListManager.removeItem(itemId)
}

function getTypeIcon (type: string): string {
  return extraFieldTypes.filter(eef => eef.type === type)[0]?.icon
}

async function onPageChanged (paging: Paging): Promise<void> {
  model.value.paging = paging
  await eventListManager.loadItems()
}

async function onCurrentCalendarChanged (id: string): Promise<void> {
  model.value.filter.calendar_id = id === 'all' ? null : id
  await eventListManager.loadItems()
}

async function prepare (): Promise<void> {
  lock.preparing = true

  try {
    calendars.value = (await calendarsApi.getCalendars()).items
  } finally {
    lock.preparing = false
  }
}

onBeforeMount(async (): Promise<void> => {
  await prepare()
  await eventListManager.prepare()
})

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_FormKit = _resolveComponent("FormKit")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createVNode(_component_router_link, {
        to: {name: 'event-create'},
        class: "btn btn-primary btn-sm"
      }, {
        default: _withCtx(() => [
          _createVNode(AppIcon, { icon: "plus" }),
          _createTextVNode(" Add event ")
        ]),
        _: 1
      })
    ]),
    (data.presentation.items.length > 0)
      ? (_openBlock(), _createElementBlock("p", _hoisted_1, _hoisted_3))
      : _createCommentVNode("", true),
    _createVNode(AppPagination, {
      "total-count": data.presentation.total_count,
      page: model.value.paging.page,
      "per-page": model.value.paging.per_page,
      disabled: lock.itemsLoading,
      onPageChanged: onPageChanged
    }, null, 8, ["total-count", "page", "per-page", "disabled"]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        (lock.preparing)
          ? (_openBlock(), _createBlock(AppLoadingMessage, {
              key: 0,
              class: "mb-2"
            }, {
              default: _withCtx(() => [
                _createTextVNode("Preparing")
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (calendars.value.length > 0)
          ? (_openBlock(), _createBlock(_component_FormKit, {
              key: 1,
              type: "select",
              placeholder: "Choose calendar",
              options: [{label: '- All', value: 'all'}, ...calendars.value.map((c) => ({label: c.title, value: c.id}))],
              onChange: _cache[0] || (_cache[0] = ($event: any) => (onCurrentCalendarChanged($event.target.value)))
            }, null, 8, ["options"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      (lock.itemsLoading)
        ? (_openBlock(), _createBlock(AppLoadingMessage, { key: 0 }, {
            default: _withCtx(() => [
              _createTextVNode("Loading events")
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    (data.presentation.items.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createElementVNode("table", _hoisted_8, [
            _hoisted_9,
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.presentation.items, (item) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: item.id
                }, [
                  _createElementVNode("td", _hoisted_10, _toDisplayString(_unref(format_date)(item.action_at, 'short')), 1),
                  _createElementVNode("td", null, _toDisplayString(item.calendar.title), 1),
                  _createElementVNode("td", null, _toDisplayString(item.title), 1),
                  _createElementVNode("td", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.extra_fields, (extraField) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: extraField.id
                      }, [
                        _createVNode(AppIcon, {
                          icon: getTypeIcon(extraField.type)
                        }, null, 8, ["icon"]),
                        (extraField.type === 'distance')
                          ? (_openBlock(), _createBlock(DistancePresentation, {
                              key: 0,
                              "event-extra-field": extraField
                            }, null, 8, ["event-extra-field"]))
                          : _createCommentVNode("", true),
                        (extraField.type === 'geolocation')
                          ? (_openBlock(), _createBlock(GeolocationPresentation, {
                              key: 1,
                              "event-extra-field": extraField
                            }, null, 8, ["event-extra-field"]))
                          : _createCommentVNode("", true),
                        (extraField.type === 'photos')
                          ? (_openBlock(), _createBlock(PhotosPresentation, {
                              key: 2,
                              "event-extra-field": extraField
                            }, null, 8, ["event-extra-field"]))
                          : _createCommentVNode("", true),
                        (extraField.type === 'price')
                          ? (_openBlock(), _createBlock(PricePresentation, {
                              key: 3,
                              "event-extra-field": extraField
                            }, null, 8, ["event-extra-field"]))
                          : _createCommentVNode("", true),
                        (extraField.type === 'volume')
                          ? (_openBlock(), _createBlock(VolumePresentation, {
                              key: 4,
                              "event-extra-field": extraField
                            }, null, 8, ["event-extra-field"]))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128))
                  ]),
                  _createElementVNode("td", null, [
                    _createElementVNode("div", _hoisted_11, [
                      _createVNode(_component_router_link, {
                        to: {name: 'event-edit', params: {id: item.id}},
                        class: "btn btn-primary btn-sm"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(AppIcon, { icon: "edit" })
                        ]),
                        _: 2
                      }, 1032, ["to"]),
                      _createVNode(AppIconLoadingButton, {
                        loading: lock.removingId === item.id,
                        icon: "trash",
                        "button-type": "danger",
                        "button-small": true,
                        disabled: !!lock.removingId,
                        onClick: ($event: any) => (removeItem(item.id))
                      }, null, 8, ["loading", "disabled", "onClick"])
                    ])
                  ])
                ]))
              }), 128))
            ])
          ])
        ]))
      : (!lock.itemsLoading && !lock.preparing)
        ? (_openBlock(), _createBlock(AppEmptyListAlert, { key: 2 }, {
            default: _withCtx(() => [
              _createTextVNode("Not events present")
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
    _createVNode(AppPagination, {
      "total-count": data.presentation.total_count,
      page: model.value.paging.page,
      "per-page": model.value.paging.per_page,
      disabled: lock.itemsLoading,
      onPageChanged: onPageChanged
    }, null, 8, ["total-count", "page", "per-page", "disabled"])
  ], 64))
}
}

})